import { QueryModelCore } from "@/core/model.core";
import { getWXOpenid, getWXUnionid } from "@/core/authUtil";

export default class Auth {
  /**
   * 云闪付静默登录
   * @param {String} code 云闪付基础授权 code
   */
  async silentYSFLogin(code) {
    const result = await new QueryModelCore('/api-mem/getYsfOpenId').post({ code });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 云闪付注册
   * @param {String} code 云闪付手机号授权 code
   */
  async registerYSF(code) {
    const result = await new QueryModelCore('/api-mem/ysfRegister').post({ code });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取微信openid
   * @param {String} code 微信授权 code
   */
  async getWXOpenidByCode(code) {
    const result = await new QueryModelCore('/api-mem/getH5OpenId').get({ code });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 发送短信验证码
   * @param {String} phone 手机号
   * @param {String} verifyCode 图形验证码
   */
  async sendMessage({ phone, verifyCode, channel = 105 }) {
    const url = '/api-mem/sendH5Message';
    const result = await new QueryModelCore(url).post({ phone, verifyCode, channel });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 注册
   * @param {String} phone 手机号
   * @param {String} verifyCode 图形验证码
   * @param {String} password 用户密码或短信验证码
   * @param {Number} type 注册类型 1-密码注册 2-短信验证码注册
   */
  async register(params) {
    const url = '/api-mem/loginH5';
    const result = await new QueryModelCore(url).post({
      type: 2,
      channel: 105,
      ...params
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取微信配置参数
   */
  async wxConfig(params) {
    const url = window.location.href;
    const result = await new QueryModelCore('/api-admin/task/getTicketInfo').get({ ...params, url });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 根据微信授权信息判断用户注册状态
   * @param {String} code 微信授权 code
   */
  async getWXRegisterInfoByCode(code) {
    const result = await new QueryModelCore('/api-mem/authH5').post({ code });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 根据微信授权信息发送短信验证码
   * @param {String} phone 手机号
   */
  async sendWXMessage({ phone }) {
    const openId = getWXOpenid();
    const unionId = getWXUnionid();
    const result = await new QueryModelCore('/api-mem/sendAuthH5Message').post({ phone, openId, unionId });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 根据微信授权信息注册
   * @param {String} phone 手机号
   * @param {String} password 用户密码或短信验证码
   */
  async wxRegister({ phone, password }) {
    const openId = getWXOpenid();
    const unionId = getWXUnionid();
    const url = '/api-mem/authH5Login';
    const result = await new QueryModelCore(url).post({
      phone,
      messageCode: password,
      openId,
      unionId
    });
    const { dataMap } = result;
    return dataMap;
  }
}